import { render, staticRenderFns } from "./DealBanner.vue?vue&type=template&id=4a22f6e9&scoped=true&"
import script from "./DealBanner.vue?vue&type=script&lang=js&"
export * from "./DealBanner.vue?vue&type=script&lang=js&"
import style0 from "./DealBanner.vue?vue&type=style&index=0&id=4a22f6e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a22f6e9",
  null
  
)

export default component.exports